const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="u-border-md u-pad-1" style="max-width: 11em;">
  <a href="#">
    Look how the last two words <span class="u-rescue-orphan">stay together</span>
  </a>
</div>
`);
            }

            getTemplateName() {
                return `6b339c46f5a5269d63c7547a38cace775a50c7d4dca267c2457e96434243e4d5`;
            }

            getSourceContext() {
                return new this.Source(``, `6b339c46f5a5269d63c7547a38cace775a50c7d4dca267c2457e96434243e4d5`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6b339c46f5a5269d63c7547a38cace775a50c7d4dca267c2457e96434243e4d5');

let template = env.loadTemplate('6b339c46f5a5269d63c7547a38cace775a50c7d4dca267c2457e96434243e4d5');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/display/demo/rescue-orphan.twig", args: context }
     );
     return rendered;;
};